import { useEffect, useState } from "react";
import { Heart, Mail, X } from "lucide-react";
import { apiClient } from "../lib/api";

const KEY = "sss_email_capture";

export const EmailCapture = () => {
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(KEY)) return;
        const t = setTimeout(() => setVisible(true), 2500);
        return () => clearTimeout(t);
    }, []);

    if (!visible) return null;

    const dismiss = () => {
        localStorage.setItem(KEY, "dismissed");
        setVisible(false);
    };

    const submit = async (e) => {
        e.preventDefault();
        try {
            await apiClient.post("/subscribe", { email });
            setDone(true);
            localStorage.setItem(KEY, "subscribed");
            setTimeout(() => setVisible(false), 2400);
        } catch {
            // keep form open on failure
        }
    };

    return (
        <div className="fixed bottom-4 left-4 z-50 safe-bottom" data-testid="email-capture">
            {open ? (
                <div className="bg-white rounded-3xl sss-shadow-lg border border-[var(--sss-border)] p-4 w-[300px] max-w-[calc(100vw-2rem)]" data-testid="email-capture-card">
                    {done ? (
                        <p className="text-sm font-medium flex items-center gap-2 py-1" data-testid="email-capture-success">
                            <Heart size={15} className="text-[var(--sss-pink)]" fill="var(--sss-pink)" strokeWidth={0} />
                            You&apos;re on the list. Sweet!
                        </p>
                    ) : (
                        <>
                            <div className="flex items-start justify-between gap-2">
                                <p className="text-sm font-semibold leading-snug">Sweet deals &amp; new treats — no spam, ever.</p>
                                <button type="button" onClick={dismiss} aria-label="Close" className="p-1 -m-1 text-[var(--sss-text-muted)] hover:text-[var(--sss-pink)]" data-testid="email-capture-close">
                                    <X size={16} />
                                </button>
                            </div>
                            <form onSubmit={submit} className="mt-3 flex gap-2">
                                <input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Your email"
                                    className="flex-1 min-w-0 rounded-full border border-[var(--sss-border)] px-4 py-2 text-sm focus:outline-none focus:border-[var(--sss-pink)]"
                                    data-testid="email-capture-input"
                                />
                                <button type="submit" className="btn-pink !px-4 !py-2 text-sm" data-testid="email-capture-submit">
                                    Join
                                </button>
                            </form>
                        </>
                    )}
                </div>
            ) : (
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className="flex items-center gap-2 bg-white text-[var(--sss-pink)] border border-[var(--sss-border)] rounded-full pl-3 pr-4 py-2.5 text-sm font-semibold sss-shadow-lg hover:-translate-y-0.5 transition"
                    data-testid="email-capture-bubble"
                >
                    <Mail size={16} /> Sweet deals
                </button>
            )}
        </div>
    );
};
